import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PortReferenceService extends BaseReferenceService {
  constructor() {
    super('PortReference');
  }
}
